import { Checkbox } from '@components/checkbox';
import { cn } from '@utils/helpers';
import type { DocumentsDropdownProps } from './types';

export const DocumentsDropdown: React.FC<DocumentsDropdownProps> = (props) => {
  return (
    <div
      className={cn(
        'absolute z-400 w-[calc(100%+8px)] overflow-hidden border-0 border-[#eceff1] bg-white px-2 transition-all duration-500 ease-in-out max-h-0 py-0 shadow-none',
        props.isVisible && 'max-h-93.75 py-1.25 shadow-[0_8px_0_rgba(0,0,0,0.1)] border!',
      )}
    >
      {props.documentLabels.map((label) => (
        <Checkbox
          key={`docLabel_${label.key} `}
          checked={Number(props.documentsChecked[label.key]) === 1}
          indeterminate={Number(props.documentsChecked[label.key]) === 2}
          updateCallback={(newVal) => props.checkFn(typeof props.id === 'string' ? [props.id] : props.id, [label.key], newVal)}
          label={label.label}
        />
      ))}
    </div>
  );
};
